import { get } from "lodash";
import log from "loglevel";
import { BasicPostDataDeserializerType } from "types";
import * as t from "./types";

export const getCurrentUserReducerResponse = (
  state: any,
  responseType: string
): t.CurrentUser => {
  log.info("Getting CurrentUser from Store...");
  const value = get(state, `currentUser.response.${responseType}`);
  return value;
};

export const getCurrentUserChangePasswordReducerResponse = (
  state: any,
  responseType: string
): BasicPostDataDeserializerType => {
  log.info("Getting CurrentUserChangePassword from Store...");
  const value = get(
    state,
    `currentUserChangePassword.response.${responseType}`
  );
  return value;
};

export const getUsersReducerResponse = (
  state: any,
  responseType: string
): t.User[] => {
  log.info("Getting Users from Store...");
  const value = get(state, `users.response.${responseType}`);
  return value;
};
